import PropTypes from "prop-types";
import { ThemeToggle } from "@/components/layout/theme-toggle.jsx";

Header.propTypes = {
  onMenuClick: PropTypes.func,
  isDrawerOpen: PropTypes.bool,
};

export default function Header({ onMenuClick, isDrawerOpen }) {
  return (
    <div
      className="bg-base-100/90 text-base-content sticky top-0 z-30 flex h-16 w-full [transform:translate3d(0,0,0)] justify-center backdrop-blur transition-shadow duration-100 print:hidden shadow-xs
  "
    >
      <div className="navbar w-full relative">
        <button
          type="button"
          onClick={onMenuClick}
          className={`lg:hidden open-close-button ${isDrawerOpen ? "open" : ""}`}
        />

        <ThemeToggle />
      </div>
    </div>
  );
}
